<template>
  <div>
    <Filtro
      :vistoria="true"
      @filtro="makeFiltro"
      @obterColaboradoresCadastro="obterColaboradoresCadastro"
    ></Filtro>

    <List
      :vistoria="true"
      :filtro="filtro"
      :realizaFiltro="realizaFiltro"
      @filtroOk="finalizaFiltro"
      :subjectPermission="subjectPermission"
      :propColaboradoresCadastro="colaboradoresCadastro"
    ></List>
  </div>
</template>

<script>
import List from './../lists/ListCotacoes';
import Filtro from './../filtros/FiltroVistorias';
export default {
  name: 'list-vistorias',
  data() {
    return {
      realizaFiltro: false,
      filtro: null,
      subjectPermission: 'Vistorias',
      colaboradoresCadastro: [],
    };
  },
  methods: {
    makeFiltro(filtro) {
      this.realizaFiltro = true;
      this.filtro = filtro;
    },
    finalizaFiltro() {
      this.realizaFiltro = false;
    },
    obterColaboradoresCadastro(colaboradores) {
      this.colaboradoresCadastro = colaboradores;
    },
  },
  components: {
    List,
    Filtro,
  },
};
</script>
